export function hasPublicAthleteRoute(path: string): boolean {
	const athletePublics = [
		'partners',
		'baevent',
		'club',
	];

	for( const p of athletePublics ) {
		if( path.includes(p) ) return true;
	}
	return false;
}